export default "__VITE_ASSET__ae314f03__"